<template>
    <div class="container">
        <content-header title="Функциональная диагностика"/>
        <p>Снятие электрокардиограммы (ЭКГ), трансторакальная эхокардиография (ЭхоКГ), дуплексное сканирование
            брахиоцефальных артерий, сосудов верхних или нижних конечностей, ультразвуковое исследование плевральных
            полостей — специальной подготовки не требует.</p>
        <p><b>Нагрузочные пробы (велоэргометрия, тредмил-тест, эргоспирометрия)</b></p>
        <div style="margin-left: 1em;">• накануне и в день процедуры рекомендуется избегать стрессовых ситуаций и
            чрезмерных физических нагрузок;<br>
            • за 12 часов до исследования запрещается курить, употреблять алкоголь, крепкий чай и кофе;<br>
            • за 2-3 часа до исследования рекомендуется легкий завтрак (стакан сока или кефира с куском хлеба);<br>
            • одежда должна быть удобной (спортивные штаны или шорты, легкие кроссовки или кеды);<br>
            • мужчинам необходимо сбрить волосяной покров с грудной клетки (чтобы избежать сигнальных помех при
            нарушении контакта электродов с кожей);<br>
            • непосредственно перед началом исследования врач функциональной диагностики проводит краткий опрос и осмотр
            пациента для исключения противопоказаний к проведению нагрузки. Пациенты с клиническими признаками ухудшения
            течения или нестабильности стенокардии, а также сердечной недостаточности не должны подвергаться
            тестированию, пока их состояние не стабилизируется.<br>
            • врач функциональной диагностики должен быть осведомлен о медикаментах, принимаемых пациентом, в связи с
            возможными отклонениями, обусловленными их приемом.<br>
            Схему отмены отдельных видов препаратов (бета-блокаторы, сердечные гликозиды, диуретики, антагонисты
            кальция, гормоны и др.) должен назначить лечащий врач заблаговременно. Не отменяются только
            противодиабетические препараты и антикоагулянты!<p></p>
        </div>
        <hr>
        <p><b>Спирография (ФВД) — исследование функции внешнего дыхания</b></p>
        <div style="margin-left: 1em;">• за 8-10 часов до исследования не принимать бронхорасширяющие препараты;<br>
            • иметь при себе ингалятор (если пациент пользуется им), носовой платок;<br>
            • не принимать спиртные и крепкие (чай, кофе) напитки;<br>
            • исследование проводится в утренние часы, натощак, после 10-20 минутного отдыха;<br>
            • лечебные процедуры и прием медикаментов перед началом исследования не допускаются;<br>
            • одежда должна быть удобной, не стесняющей дыхательные движения;<br>
            • обязательно наличие результатов флюорографического обследования.
        </div>
        <hr>
        <p><b>Суточное мониторирование ЭКГ и АД</b></p>
        <div style="margin-left: 1em;">• прием или отмена препаратов накануне и в день исследования должны быть
            согласованы с лечащим врачом;<br>
            • мониторирование нельзя проводить в день интенсивных диагностических обследований, в том числе взятия крови
            для анализов, рентгеновского исследования, МРТ, КТ, физиотерапевтических процедур;<br>
            • для лучшего контакта электродов с кожей мужчинам необходимо сбрить волосяной покров с грудной клетки;<br>
            • во время исследования рекомендуется надевать хлопчатобумажное нижнее белье и стараться не носить одежду из
            электризующихся синтетических и шелковых тканей;<br>
            • нельзя принимать общие водные процедуры (ванна, душ), подвергаться длительным, тяжелым физическим
            нагрузкам, т.к. повышенное потоотделение может привести к отклеиванию электродов;<br>
            • при проведении мониторирования пациентам не рекомендуется находиться вблизи мощных линий электропередач,
            трансформаторных будок, пользоваться компьютером, мобильным телефоном и т.п.<br>
            • не подвергать прибор ударам, воздействию вибраций, высоких и низких температур.
        </div>
        <hr>
        <p><b>Электроэнцефалография</b></p>
        <div style="margin-left: 1em;">• накануне исследования помыть голову; использование гелей, пенок, лаков для
            волос перед проведением исследования не рекомендуется;<br>
            • серьги необходимо снять (желательно дома);<br>
            • накануне и в день процедуры рекомендуется избегать стрессовых ситуаций и чрезмерных физических
            нагрузок;<br>
            • за 12 часов до исследования запрещается курить, употреблять алкоголь, крепкий чай, кофе, колу, кофеин– и
            таурин-содержащие газированные напитки;<br>
            • за 2-3 часа до исследования рекомендуется легкий завтрак (стакан сока или кефира с куском хлеба);<br>
            • если в направлении на ЭЭГ указана проба с депривацией сна – это значит, что накануне исследования пациенту
            нельзя спать не менее 24-36 часов (продолжительность депривации сна зависит от возраста пациента и в
            обязательном порядке должна согласовываться с лечащим врачом неврологом);<br>
            • отмена противоэпилептических препаратов должна обязательно согласовываться с лечащим врачом-эпилептологом
            и иметь особые показания, которые должны быть отражены в направлении на исследование.
        </div>
        <hr>
        <p><b>Дуплексное сканирование брюшной аорты, почечных артерий</b></p>
        <div style="margin-left: 1em;">• за 3 дня до обследования необходимо исключить из рациона хлеб из тёмной муки;
            молоко в любом виде (каши и супы на молоке, чай и кофе с молоком); овощи и фрукты, способствующие
            газообразованию (фасоль, горох, капуста, виноград, яблоки, сливы); сладкие и мучные блюда (торты, пирожки);
            любые газированные напитки;<br>
            • за день до исследования принимать эспумизан по 2 капсулы 3 раза в сутки, утром в день исследования 2
            капсулы, не запивая водой (или за 3 дня принимать активированный уголь по 2 таблетки 2 раза в день);<br>
            • исследование проводится строго натощак, последний прием пищи не менее, чем за 6 часов до обследования.
            Если ультразвук назначен на послеобеденное время, утром можно позволить себе легкий завтрак.
        </div>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";

export default {
    name: "Функциональная диагностика",
    components: {
        ContentHeader
    },
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: center;
    width: 225px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

.link {
    color: #006688;
    border-bottom: 1px dotted #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
}

.left-30px {
    margin-left: 30px;
}

hr {
    display: block;
    unicode-bidi: isolate;
    margin-block-start: 0.5em;
    margin-block-end: 0.5em;
    margin-inline-start: auto;
    margin-inline-end: auto;
    overflow: hidden;
    border-style: inset;
    border-width: 1px;
    color: #666;
    line-height: 1;
}

</style>
